export const navLinks = [
  { label: "首页", path: "/" },
  { label: "影视分类", path: "/category" },
  { label: "最新资讯", path: "/category?sort=latest" },
  { label: "专题合集", path: "/#topics" },
  { label: "关于", path: "/about" },
  { label: "联系", path: "/contact" },
];

export const typeCategories = [
  { key: "电影", icon: "ri-film-line", desc: "大银幕的极致想象" },
  { key: "电视剧", icon: "ri-tv-2-line", desc: "长篇叙事里的众生相" },
  { key: "网剧", icon: "ri-smartphone-line", desc: "轻量而锋利的表达" },
  { key: "纪录片", icon: "ri-camera-lens-line", desc: "真实世界的深邃切片" },
  { key: "综艺", icon: "ri-mic-line", desc: "热闹深处的真诚" },
  { key: "动漫", icon: "ri-magic-line", desc: "幻想与青春的交汇" },
];

export const filterRegions = ["大陆", "港台", "欧美", "日韩"];

export const filterYears = ["2025", "2024", "2023", "2022", "2021"];

export const filterTags = [
  "剧情", "爱情", "悬疑", "犯罪", "科幻", "动作", "家庭", "治愈", "年代", "喜剧", "自然", "都市",
];

export const sortOptions = [
  { key: "latest", label: "按发布时间" },
  { key: "heat", label: "按热度" },
  { key: "rating", label: "按评分" },
];

export const topics = [
  {
    id: "t1",
    title: "都市女性图鉴",
    subtitle: "她们的故事，也是我们的故事",
    tag: "都市",
    desc: "聚焦当代都市女性的困境与成长，从职场到婚姻，从理想到现实，看她们如何在一地鸡毛里活成自己的光。",
    movieIds: ["1", "10", "7"],
    cover: "https://readdy.ai/api/search-image?query=editorial%20collage%20of%20confident%20asian%20women%20in%20a%20modern%20city%2C%20deep%20wine%20red%20and%20gold%20tones%2C%20magazine%20style%20cover%2C%20soft%20studio%20lighting%2C%20high%20detail&width=800&height=600&seq=topic-cover-01&orientation=landscape",
  },
  {
    id: "t2",
    title: "年度悬疑精选",
    subtitle: "真相，永远藏在你以为之外",
    tag: "悬疑",
    desc: "精选高分悬疑与犯罪题材作品，层层反转、步步紧逼，献给所有热爱烧脑推理的观众。",
    movieIds: ["2", "7", "11"],
    cover: "https://readdy.ai/api/search-image?query=moody%20noir%20editorial%20cover%20of%20a%20rainy%20neon%20city%20alley%20with%20shadows%2C%20charcoal%20and%20red%20tones%2C%20cinematic%20atmosphere%2C%20high%20detail&width=800&height=600&seq=topic-cover-02&orientation=landscape",
  },
  {
    id: "t3",
    title: "治愈系纪录片",
    subtitle: "慢下来，看看这个世界",
    tag: "自然",
    desc: "从山海到荒野，用最诚实的镜头记录自然与人文。适合在一个安静的午后，慢慢看完。",
    movieIds: ["4", "12", "8"],
    cover: "https://readdy.ai/api/search-image?query=serene%20documentary%20cover%20of%20misty%20mountains%20and%20a%20calm%20sea%20at%20sunrise%2C%20sage%20green%20and%20gold%20tones%2C%20peaceful%20natural%20atmosphere%2C%20high%20detail&width=800&height=600&seq=topic-cover-03&orientation=landscape",
  },
  {
    id: "t4",
    title: "华语年代剧经典",
    subtitle: "时代洪流中的普通人",
    tag: "年代",
    desc: "走过旧时光，看一代代人如何在历史里扎根、生长、留下自己的名字。",
    movieIds: ["3", "9", "10"],
    cover: "https://readdy.ai/api/search-image?query=nostalgic%20editorial%20cover%20of%20an%20old%20chinese%20town%20street%20at%20golden%20dusk%2C%20warm%20sepia%20and%20amber%20tones%2C%20cinematic%20atmosphere%2C%20high%20detail&width=800&height=600&seq=topic-cover-04&orientation=landscape",
  },
];

export const stats = [
  { value: "12,800+", label: "收录影视作品" },
  { value: "3,600+", label: "演员资料档案" },
  { value: "980+", label: "深度剧情解读" },
  { value: "46", label: "专题合集" },
];